import csCZLang from './cs.js'
import skSKLang from './sk.js'
import huHULang from './hu.js'
import csHULang from './cs_HU.js'
import csSKLang from './cs_SK.js'
import skCZLang from './sk_CZ.js'
import skHULang from './sk_HU.js'
import ukCZLang from './uk_CZ.js'
import ukSKLang from './uk_SK.js'
import ukHULang from './uk_HU.js'
import ruCZLang from './ru_CZ.js'
import ruSKLang from './ru_SK.js'
import ruHULang from './ru_HU.js'
import enCZLang from './en_CZ.js'
import enSKLang from './en_SK.js'
import enHULang from './en_HU.js'
import huCZLang from './hu_CZ.js'
import huSKLang from './hu_SK.js'

export const langs = {
  csCZLang,
  csHULang,
  csSKLang,
  skCZLang,
  skHULang,
  skSKLang,
  ukCZLang,
  ukHULang,
  ukSKLang,
  ruCZLang,
  ruHULang,
  ruSKLang,
  enCZLang,
  enHULang,
  enSKLang,
  huHULang,
  huCZLang,
  huSKLang
}
